// client/src/utils/media.js
// In production this is left unset (empty string = relative paths), so
// requests go to the site's own origin (e.g. https://Store.insollex.com/api/...)
// and IIS's reverse-proxy rules (see client/public/web.config) forward them to
// the Express API. For local dev, set REACT_APP_API_URL in .env.development
// (defaults to http://localhost:5000, where the API runs directly).
export const API_BASE_URL = process.env.REACT_APP_API_URL || '';

// Uploaded product/auction images are stored as paths relative to the API
// server (e.g. "/uploads/123.png"), while seed/demo data uses full external
// URLs (e.g. placehold.co). Only relative paths need the API host prefixed —
// otherwise the browser resolves them against the React dev server's own
// origin (port 3000), which is why uploaded images wouldn't load.
export const getImageUrl = (path) => {
  if (!path) return path;
  if (/^https?:\/\//i.test(path)) return path;
  return `${API_BASE_URL}${path}`;
};
